import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { fetchJob } from '../../actions/job';
import ConfirmDetails from './confirmDetails/confirmDetails';
import PreScreening from './preScreeningQuestions/preScreeningQuestions';
import FinishForm from './finishForm/finishForm';
import api from '../../api/apiSettings';
import ErrorForm from './ErrorWindow/ErrorForm';
import BasicForm from './basicForm/basicForm';
import WithCloseIcon from '../common/ComposableWrappers/WithCloseIcon/WithCloseIcon';
import { getSerializedSearchParams, useURLParams } from '../../utils/helpers';

function QuickApply() {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useURLParams();
  const completedProfile = localStorage.getItem('userProfileCompleted') === 'true';

  const convertToFormData = (json) => {
    const formData = new FormData();

    Object.entries(json).forEach((item) => {
      formData.append(item[0], item[1]);
    });

    return formData;
  };
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    JobId: JSON.parse(localStorage.getItem('OpenedJobId') || searchParams.get('id') || false),
    UserId: Number(localStorage.getItem('UserId')),
    PhoneCountryCode: '',
    Phone: '',
    Cv: undefined,
    Country: '',
    ApplicationSource: params?.utm_source || '',
    ApplicationSourceDrillDown1: params?.utm_medium || '',
    ApplicationSourceDrillDown2: params?.utm_campaign || '',
    // eslint-disable-next-line no-underscore-dangle -- _hsenc is a HubSpot URL query param name
    HubSpotCampaign: params?._hsenc || '',
    PageUrl: document.URL,
    PageTitle: ''
  });
  const [error, setError] = useState(null);
  const [questions, setQuestions] = useState({});
  const [noDoubleCheckoForApply, setCheckForApply] = useState(true);
  const [userDataExist, setUserDataExist] = useState(false);

  const isAuthenticated = useIsAuthenticated();
  const job = useSelector((state) => state.job.response);
  const user = useSelector((state) => state.user?.profile);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const close = () => setSearchParams({ ...getSerializedSearchParams(), action: '' });

  const closeHandler = () => {
    localStorage.removeItem('OpenedJobId');
    setStep(1);
    close();
  };

  useEffect(() => {
    if (user && user.Phone && user.PhoneCountryCode && user.CvName) {
      setUserDataExist(true);
    }
  }, [user]);

  // useEffect(() => {
  //   if (!mounted.current) {
  //     mounted.current = true;
  //   } else {
  //     completedProfile = localStorage.getItem('userProfileCompleted') === 'true';
  //     if (isAuthenticated) {
  //       const authority = getAuthority();
  //       const msalInstance = new PublicClientApplication(msalConfig(authority));
  //       msalInstance
  //         .acquireTokenSilent({
  //           scopes: loginRequest.scopes,
  //           account: {}
  //         })
  //         .then(({ accessToken }) => {
  //           localStorage.setItem(ACCESS_TOKEN_NAME, accessToken);

  //           backendAuth().then((response) => {
  //             if (response.status === 200) {
  //               localStorage.setItem('AirswiftFirstName', response.data.Data.FirstName);
  //               localStorage.setItem('UserId', response.data.Data.Id);
  //               setData({ ...data, UserId: Number(response.data.Data.Id), PageTitle: job?.JobTitle || '' });

  //               backendUser(response.data.Data.Id).then((userResponse) => {
  //                 if (userResponse.status === 200) {
  //                   localStorage.setItem('userProfileCompleted', userResponse.data.Data.IsProfileCompleted);
  //                   dispatch(fetchUserData(response.data.Data.Id));
  //                   dispatch(fetchJob(data.JobId));
  //                 }
  //               });
  //             }
  //           });
  //         });
  //     }
  //   }
  // }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      if (!data.JobId) {
        close();
        return;
      }
      dispatch(fetchJob(data.JobId));
      // dispatch(fetchUserData(data.UserId));
    }
  }, []);

  useEffect(() => {
    if (job && job.Id === data.JobId) {
      if (job.IsApplied && noDoubleCheckoForApply) {
        setError('Candidate has already applied to the Job');
        setStep('error');
      } else {
        setCheckForApply(false);
      }
      setQuestions({
        Question1: job.Question1,
        Question2: job.Question2,
        Question3: job.Question3
      });
    }
  }, [job]);

  const steps = {
    1: (
      <ConfirmDetails
        nextHandle={(newData) => {
          setStep(2);
          setData((prevState) => ({
            ...prevState,
            ...newData,
            PageTitle: job?.JobTitle || ''
          }));
        }}
        data={data}
        completedProfile={completedProfile}
        questions={questions}
        userDataExist={userDataExist}
      />
    ),
    2: (
      <PreScreening
        nextHandle={async (newData) => {
          try {
            await api.post(
              `v1/job-application${completedProfile || userDataExist ? '' : '/quick-apply'}`,
              convertToFormData(
                Object.fromEntries(Object.entries({ ...data, ...newData }).filter(([, v]) => Boolean(v) || v === false))
              ),
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            );

            setStep(3);
            setData((prevState) => ({
              ...prevState,
              ...newData,
              PageTitle: job?.JobTitle || ''
            }));
          } catch (e) {
            const {
              status,
              statusText,
              data: { errors }
            } = e.response;
            setError(
              `${status} - ${statusText || Object.values(errors).reduce((resultString, val) => resultString + val, '')}`
            );
            setStep('error');
          }
        }}
        backHandle={() => setStep(1)}
        questions={questions}
      />
    ),
    3: <FinishForm completedProfile={completedProfile} />,
    error: <ErrorForm error={error} cancel={close} backHandle={() => setStep(1)} />
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      errorComponent={(props) => {
        console.info(JSON.stringify(props));
        return navigate(-1);
      }}
      authenticationRequest={{
        ...loginRequest,
        redirectUri: `${window.location.origin}/dashboard/jobs`,
        state: JSON.stringify({ navigate: `/dashboard${window.location.href.replace(window.location.origin, '')}` })
      }}
    >
      <BasicForm cancel={closeHandler} blue={step === 3 && !completedProfile}>
        <WithCloseIcon close={closeHandler}>{steps[step]}</WithCloseIcon>
      </BasicForm>
    </MsalAuthenticationTemplate>
  );
}
export default QuickApply;
